/** @jsxImportSource theme-ui */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DisableTRANSPAR } from 'utils/constants';

import { RisksProjectionCard } from 'components/RisksProjectionCard';

import { setSelectedRiskType } from 'diseaseActivitiesInCountryLocations/diseaseActivitiesInCountryLocations.slice';
import diseaseActivityDetailsSelectors from 'diseaseActivitiesInCountryLocations/diseaseActivityDetails.selectors';
import { openPanel } from 'diseaseActivityPanels/diseaseActivityPanels.saga';
import diseaseActivityPanelsSelectors from 'diseaseActivityPanels/diseaseActivityPanels.selectors';

export const RiskCardForCountry: React.FC = () => {
  const dispatch = useDispatch();
  const importationRisk = useSelector(diseaseActivityDetailsSelectors.importationRisk);
  const exportationRisk = useSelector(diseaseActivityDetailsSelectors.exportationRisk);
  const outbreakPotentialCategory = useSelector(
    diseaseActivityDetailsSelectors.outbreakPotentialCategory
  );
  const diseaseInformation = useSelector(diseaseActivityDetailsSelectors.diseaseInformation);
  const selectedRiskType = useSelector(diseaseActivityDetailsSelectors.selectedRiskType);
  const selectedRisk = useSelector(diseaseActivityDetailsSelectors.selectedRisk);
  const disacParams = useSelector(diseaseActivityPanelsSelectors.disacParams);
  const { hasParameters } = disacParams;

  return (
    <RisksProjectionCard
      importationRisk={importationRisk}
      exportationRisk={exportationRisk}
      outbreakPotentialCategory={outbreakPotentialCategory}
      diseaseInformation={diseaseInformation}
      onClick={
        !DisableTRANSPAR && !selectedRisk?.isModelNotRun && !selectedRisk?.isModelRunning
          ? () => dispatch(openPanel({ panel: 'RiskParameters' }))
          : undefined
      }
      isSelected={!DisableTRANSPAR && hasParameters}
      riskType={selectedRiskType}
      onRiskTypeChanged={riskType => dispatch(setSelectedRiskType(riskType))}
    />
  );
};
